const hostname = window.location.hostname;

// REPORTING_BASE_URL -> the standalone SaloraReporting service (merchant reports, :8081).
const CONFIG_MAP = {
  "loan.sparkruppe.online": {
    ENV_LABEL: "production",
    API_BASE_URL: "https://api.sparkruppe.online",
    REPORTING_BASE_URL: "https://report.sparkruppe.online",
  },
  "lms.sparkruppe.online": {
    ENV_LABEL: "production",
    API_BASE_URL: "https://pg.sparkruppe.online/api",
    REPORTING_BASE_URL: "https://report.sparkruppe.online",
  },
  "lms.saloracapital.com": {
    ENV_LABEL: "production",
    API_BASE_URL: "https://lmsapi.saloracapital.com",
  },
  "lmsfront.saloracapital.com": {
    ENV_LABEL: "dev",
    API_BASE_URL: "https://devlmsapi.saloracapital.com",
    // API_BASE_URL: "https://lmsapi.saloracapital.com",

  },
  "localhost": {
    ENV_LABEL: "local",
    // Local backend (SaloraCaptial) runs on 8080.
    API_BASE_URL: "http://localhost:8080",
    // Standalone reporting service runs on 8081.
    REPORTING_BASE_URL: "http://localhost:8081",
   // API_BASE_URL: "https://devlmsapi.saloracapital.com",

   },
};

const config = CONFIG_MAP[hostname] || {
  ENV_LABEL: "local",
 API_BASE_URL: "http://localhost:8080",
 REPORTING_BASE_URL: "http://localhost:8081",
};

export default config;
